import { gql } from '@apollo/client';

export const GET_CHECKGRADESDEATIL = gql`
  query SkWeb_StudentList_CheckGrades(
    $classroomId: ID
    $username: String
    $studentId: ID
    $page: Int
    $pageSize: Int
  ) {
    studentList(
      classroomId: $classroomId
      username: $username
      studentId: $studentId
      page: $page
      pageSize: $pageSize
    ) {
      data {
        id
        name
        username
        product {
          id
          name
        }
      }
      totalCount
    }
  }
`;
